import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  
  // Determinar qué token usar según la URL del request
  let token: string | null = null;
  
  // Si es una ruta de tenant (empleado), usar token de empleado
  if (req.url.includes('/api/tenant/')) {
    token = storageService.getEmployeeToken();
  } 
  // Si es una ruta de owner o admin, usar token de owner
  else if (req.url.includes('/api/owner/') || req.url.includes('/api/admin/')) {
    // Primero intentar obtener el token de owner principal
    token = storageService.getToken();
    
    // Si no hay token principal, verificar si el employee es owner
    if (!token) {
      const employee = storageService.getEmployee();
      if (employee?.is_owner && employee.owner_data?.owner_token) {
        token = employee.owner_data.owner_token;
      }
    }
  }
  // Para otras rutas, intentar con token de owner primero, luego empleado
  else {
    token = storageService.getToken() || storageService.getEmployeeToken();
  }

  // Clone request and add authorization header if token exists
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      }
    });
  } else {
    req = req.clone({
      setHeaders: {
        Accept: 'application/json',
      }
    });
  }

  return next(req);
};
